// extracted by mini-css-extract-plugin
export default {"root":"back_button_root__pojXp"};